// Agreement Queue — the office-priorities chat over the agreements on the plate. A thin
// wrapper over the shared AgentChatModal. (Ken 2026-10-12)
import AgentChatModal from './AgentChatModal'
import { artifacts } from '../api'

export default function PrioritiesChat({ onClose }: { onClose: () => void }) {
  return (
    <AgentChatModal
      title="Agreement Queue"
      subtitle="Ask about the agreements on the plate — e.g. “prioritize with me”."
      suggestions={['Prioritize with me', 'Waiting in intake', 'Delivered to submitters']}
      ask={(messages) => artifacts.priorityChat(messages)}
      onClose={onClose}
    />
  )
}
